/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceIdQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ResourceIdQueryOperator");
    }

    getFixupPrototypeFunction() { return ResourceIdQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ResourceIdQueryOperator>): ResourceIdQueryOperator {
        let obj = Object.assign(new ResourceIdQueryOperator(), model);
        ResourceIdQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceIdQueryOperator>): ResourceIdQueryOperator {
        if (!model) return null;
        return ResourceIdQueryOperator.newInstance(<ResourceIdQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceIdQueryOperator) {
        if (!obj) return;

        models.ResourceIdQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceIdQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResourceIdQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Resource IDs to include
     */
    resource_ids: Array<string>;

}
